var _rect, _path, _ellipse, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.832031,
    y: 0.833008,
    width: 28.3333,
    height: 28.3333,
    rx: 14.1667,
    strokeOpacity: 0.91
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3696 8.33301H9.97024C8.34887 8.33301 7.02323 9.62114 7.00963 11.2425C6.98868 13.7416 7.0056 16.6169 7.0253 18.7138C7.0407 20.3528 8.37249 21.6663 10.0116 21.6663C12.6814 21.6663 16.6865 21.6663 20.0019 21.6663C21.6587 21.6663 23 20.3232 23 18.6663V14.6663C23 13.0095 21.6569 11.6663 20 11.6663H9.43478",
    strokeOpacity: 0.91,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.9987,
    cy: 16.6667,
    rx: 1.66667,
    ry: 1.66667,
    fillOpacity: 0.91
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1654 16.6667C21.1654 17.311 20.643 17.8333 19.9987 17.8333C19.3544 17.8333 18.832 17.311 18.832 16.6667C18.832 16.0223 19.3544 15.5 19.9987 15.5C20.643 15.5 21.1654 16.0223 21.1654 16.6667Z",
    strokeOpacity: 0.91
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_paint",
    x1: 0.777771,
    y1: 19.1734,
    x2: 36.2222,
    y2: 19.1734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.4059b2fbeb51a138d7d70b23c7048e01.svg";
export { ForwardRef as ReactComponent };